import { ElementRef, Inject, Injectable, PLATFORM_ID, Renderer2, RendererFactory2  } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DOCUMENT, isPlatformServer } from '@angular/common';
import { delay, shareReplay, debounceTime } from 'rxjs/operators';
import { WindowRef } from './window-ref.service';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private renderer: Renderer2;
  private serverEnvironmentClass: string;
  private isServer: boolean;
  protected layoutSize$ = new Subject();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private windowRef: WindowRef,
    private rendererFactory: RendererFactory2,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.isServer = isPlatformServer(this.platformId);
  }

  protected layoutSizeChange$ = this.layoutSize$.pipe(
    shareReplay({ refCount: true }),
  );

  changeLayoutSize() {
    this.layoutSize$.next();
  }

  onChangeLayoutSize(): Observable<any> {
    return this.layoutSizeChange$.pipe(delay(1));
  }

  onSafeChangeLayoutSize(): Observable<any> {
    return this.layoutSizeChange$.pipe(
      debounceTime(350),
    );
  }

  setEnvironmentClass() {
    if (!this.isServer) {
      this.renderer.removeClass(this.document.body, this.serverEnvironmentClass);
    }
  }

  getViewportHeight(): number {
    return this.windowRef.nativeWindow.innerHeight || this.document.documentElement.clientHeight;
  }

  getViewportWidth(): number {
    return this.windowRef.nativeWindow.innerWidth || this.document.documentElement.clientWidth;
  }

  getElementPosition(element: ElementRef): DOMRect {
    return element.nativeElement.getBoundingClientRect() || { width: 0, height: 0, x: 0, y: 0 };
  }

  getScrollTop(): number {
    return this.windowRef.nativeWindow.pageYOffset || this.document.documentElement.scrollTop;
  }
}
